window.theme = window.theme || {};

/* ================ SLATE ================ */
window.theme = window.theme || {};

$.extend(true, theme.libs, {
  "navigation-section": {
    "js": "//www.teleseen.lk/cdn/shop/t/2/assets/bt-section-navigation.min.js?v=51196758992662950121755155545"
  },
  "navigation-vertical-section": {
    "js": "//www.teleseen.lk/cdn/shop/t/2/assets/bt-section-navigation-vertical.min.js?v=33634404436856514401755155545"
  },
  "product-tabs-section": {
    "js": "//www.teleseen.lk/cdn/shop/t/2/assets/bt-section-product-tabs.min.js?v=173456301371291064631755155545"
  },
  "instagram-section": {
    "js": "//www.teleseen.lk/cdn/shop/t/2/assets/bt-section-instagram.min.js?v=119371711670684112801755155545"
  },
  "rich-banner-text-section": {
    "js": "//www.teleseen.lk/cdn/shop/t/2/assets/bt-section-rich-banner-text.min.js?v=151443700536332936361755155545"
  },
  "layer-banner-section": {
    "js": "//www.teleseen.lk/cdn/shop/t/2/assets/bt-section-layer-banner.min.js?v=167445518760159710531755155545"
  },
  "simple-product-slider-section": {
    "js": "//www.teleseen.lk/cdn/shop/t/2/assets/bt-section-simple-product-slider.min.js?v=153646191602202855131755155545"
  },
  "product-columns-section": {
    "js": "//www.teleseen.lk/cdn/shop/t/2/assets/bt-section-product-columns.min.js?v=165423569460926413211755155545"
  },
  "map-section": {
    "js": "//www.teleseen.lk/cdn/shop/t/2/assets/bt-section-map.min.js?v=114309059772453931521755155545"
  },
  "quotes-section": {
    "js": "//www.teleseen.lk/cdn/shop/t/2/assets/bt-section-quotes.min.js?v=144313337819941354051755155545"
  },
  "logo-bar-section": {
    "js": "//www.teleseen.lk/cdn/shop/t/2/assets/bt-section-logo-bar.min.js?v=128265452728272567801755155545"
  },
  "single-deal-section": {
    "js": "//www.teleseen.lk/cdn/shop/t/2/assets/bt-section-single-deal.min.js?v=25458204786684868451755155545"
  },
  "about-section": {
    "js": "//www.teleseen.lk/cdn/shop/t/2/assets/bt-section-about.min.js?v=8502415123109276991755155544"
  },
  "newsletter-section": {
    "js": "//www.teleseen.lk/cdn/shop/t/2/assets/bt-section-newsletter.min.js?v=141531588240217245561755155545"
  },
  "featured-blog-section": {
    "js": "//www.teleseen.lk/cdn/shop/t/2/assets/bt-section-featured-blog.min.js?v=144183644309553950851755155544"
  },
  "collection-filter-section": {
    "css": ["//www.teleseen.lk/cdn/shop/t/2/assets/bt-section-collection-filter.scss.css?v=140444828555474866441755155603"],
    "js": "//www.teleseen.lk/cdn/shop/t/2/assets/bt-section-collection-filter.min.js?v=159256249842827427851755155544"
  },
  "footer-section": {
    "js": "//www.teleseen.lk/cdn/shop/t/2/assets/bt-section-footer.min.js?v=84265135187866612071755155544"
  },
  "product-section": {
    "js": "//www.teleseen.lk/cdn/shop/t/2/assets/bt-section-product.min.js?v=86218975044554467881755155545"
  },
  "collection-template-section": {
    "js": "//www.teleseen.lk/cdn/shop/t/2/assets/bt-collection.min.js?v=158190137126882093371755155544"
  },
  "search-template-section": {
    "js": "//www.teleseen.lk/cdn/shop/t/2/assets/bt-search.min.js?v=2754633890779128051755155544"
  },
  "cart-template-section": {
    "js": "//www.teleseen.lk/cdn/shop/t/2/assets/bt-cart-page.min.js?v=30941263538444292921755155544"
  },
  "zoom": {
    "js": "//www.teleseen.lk/cdn/shop/t/2/assets/cloudzoom.js?v=14062328003065750181755155545"
  }
});

theme.dependTypeLibs = {
  "navigation-vertical": "navigation-section",
  "product": "product-global"
};

theme.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

theme.Sections.prototype = _.assignIn({}, theme.Sections.prototype, {
  _beforeCreateInstance: function(container, constructor, type) {
    if(!type) {
      type = $(container).attr('data-section-type');
    }
    if(theme.dependTypeLibs[type] == undefined) {
      BT.loadCssJsLib(type + '-section', function() {
        if(this.constructors[type] == undefined) {
          this.constructors[type] = constructor;
        }
        this._createInstance(container, constructor);
      }.bind(this));
    } else {
      BT.loadCssJsLib(theme.dependTypeLibs[type], function() {
        BT.loadCssJsLib(type + '-section', function() {
          if(this.constructors[type] == undefined) {
            this.constructors[type] = constructor;
          }
          this._createInstance(container, constructor);
        }.bind(this));
      }.bind(this));
    }
  },

  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (_.isUndefined(constructor)) {
      return;
    }

    var instance = _.assignIn(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._beforeCreateInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    this.instances = _.filter(this.instances, function(instance) {
      var isEventInstance = instance.id === evt.detail.sectionId;

      if (isEventInstance) {
        if (_.isFunction(instance.onUnload)) {
          instance.onUnload(evt);
        }
      }

      return !isEventInstance;
    });
  },

  _onSelect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onSelect)) {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onDeselect)) {
      instance.onDeselect(evt);
    }
  },

  _onBlockSelect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockSelect)) {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockDeselect)) {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    $('[data-section-type=' + type + ']').each(
      function(index, container) {
        this._beforeCreateInstance(container, constructor, type);
      }.bind(this)
    );
  }
});

window.slate = window.slate || {};

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 * Alternatives
 * - Accounting.js - http://openexchangerates.github.io/accounting.js/
 *
 */

theme.Currency = (function() {
  var moneyFormat = '$'; // eslint-disable-line camelcase

  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || moneyFormat;

    function formatWithDelimiters(number, precision, thousands, decimal) {
      thousands = thousands || ',';
      decimal = decimal || '.';

      if (isNaN(number) || number === null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        '$1' + thousands
      );
      var centsAmount = parts[1] ? decimal + parts[1] : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'");
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/*================ SECTIONS ================*/
window.theme = window.theme || {};

theme.sections = new theme.Sections();
BT.loadRequireCss();
BT.init();
function registerSections() {
  theme.sections.register('navigation', theme.DesktopNavigationSection);
  theme.sections.register('navigation-vertical', theme.VerticalNavigationSection);
  theme.sections.register('instagram', theme.InstagramSection);
  theme.sections.register('rich-banner-text', theme.RichBannerTextSection);
  theme.sections.register('layer-banner', theme.LayerBannerSection);
  theme.sections.register('simple-product-slider', theme.SimpleProductSliderSection);
  theme.sections.register('product', theme.ProductTemplateSection);
  theme.sections.register('product-tabs', theme.ProductTabsSection);
  theme.sections.register('product-columns', theme.ProductColumnsSection);
  theme.sections.register('map', theme.Maps);
  theme.sections.register('quotes', theme.QuotesSection);
  theme.sections.register('featured-blog', theme.FeaturedBlogSection);
  theme.sections.register('logo-bar', theme.LogoListSection);
  theme.sections.register('single-deal', theme.SingleDealSection);
  theme.sections.register('about', theme.AboutSection);
  theme.sections.register('newsletter', theme.NewsletterSection);
  theme.sections.register('collection-filter', theme.CollectionFilterSection);
  theme.sections.register('footer', theme.FooterSection);
  theme.sections.register('collection-template', theme.CollectionTemplateSection);
  theme.sections.register('search-template', theme.SearchTemplateSection);
  theme.sections.register('cart-template', theme.CartTemplateSection);
}
if(BT.data.cacheWindowWidth <= BT.options.windowScreen.mobile) {
  $(document).ready(function() {
    registerSections();
  });
} else {
  registerSections();
}
if (window.self === window.top && 'serviceWorker' in navigator && theme.pwaEnable) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/a/bt-toolkit/js/sw.js',{ scope: "/" })
      .then(function (registration) {
        registration.update();
      })
      .catch((err) => console.log("Error", err));
  });
}


//=================================


            $(function () {
              
              
              
              $("#ContactFormShowrom").change(function(){
                 $(".showroombox").text("");
                      var showroom =$("#ContactFormShowrom").val();
                    // console.log('====>>>-'+ showroom);


                  Object.keys(showroomarray).forEach(function (key) {
                   // console.log('key: ' + key);
                    if(key==showroom){



                     var address = showroomarray[key]["address"];
                      var phone = showroomarray[key]["phone"];

                 //console.log('==========>>'+address);
                       $(".showroombox").append("<p>Address : "+address+"</p><p>Phone : "+phone+"</p>");



                      }
                  });


                });

              
              
              
                 $(".showroomvisitBtn").click(function(){
                 $(".showroomform").toggle();
                 $(".hr").toggle();
                 // $(".showroomform").css("display","block","important");

                   });
              
              
              
			    
              //======================================================
               ///recent product view
              //======================================================
              /*
                setTimeout(
                  function() 
                  {
                    //do something special
               // console.log('ppppppp');
                     productcount = $('.recent-view-list .grid__item').length;
                  console.log('productcount ===>> '+productcount);
                  if(productcount < 2){

                        $(".rencent-view-ele").css("display","none");

                  }
                    
                    
                    
                  }, 3500);
               */
              
                //========================================================
                  //You may also like these products
                //========================================================
               /*
                 youmaycount = $(".upsell-ele").children().length;
                 if(youmaycount < 5){

                        $(".upsell-ele").css("display","none");

                  }
              */
              //===========================================================
              
                 
            //	var disabledDates = ["2020-10-28","2020-10-14","2020-10-21"]

            $('#datepicker1').datepicker({
                beforeShowDay: function(date){
                    var string = jQuery.datepicker.formatDate('yy-mm-dd', date);
                    return [ disabledDates.indexOf(string) == -1 ]
                }
            });
              
              

             
              
              
            });
        